<template>
  <b-form-group
    label="6. Indikasi Tercatat Ganda"
    label-for="isIndikasiGanda"
  >
    <b-form-radio
      v-model="isIndikasiGanda"
      disabled
      value="1"
    >
      Terindikasi Tercatat Ganda Dengan
    </b-form-radio>
    <b-col
      v-if="isIndikasiGanda === '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-select
        v-model="indikasiGandaDengan"
        :options="dataIndikasiGandaDengan"
        disabled
      />

      <b-col
        cols="11"
        offset-md="1"
        class="mt-1 pr-0"
      >
        <b-form-group
          v-if="indikasiGandaDengan === '1' || indikasiGandaDengan === '2'"
          label="Sebutkan"
          label-for="indikasiGandaSebutkan"
        >
          <slot />
        </b-form-group>
      </b-col>
    </b-col>
    <b-form-radio
      v-model="isIndikasiGanda"
      value="0"
      disabled
    >
      Tidak Tercatat Ganda
    </b-form-radio>
  </b-form-group>
</template>
<script>
export default {
  props: {
    isIndikasiGanda: { type: String, default: null },
    indikasiGandaDengan: { type: String, default: null },
  },
  data() {
    return {
      dataIndikasiGandaDengan: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Pusat' },
        { value: '2', text: 'Pemerintah Daerah Lain' },
        { value: '3', text: 'PD/UKPD' },
      ],
    }
  },
}
</script>
